<template>
  <div>

    <!-- <div class="container-fluid">
      <v-row class="app-course">
        <v-col cols="12" sm="12" md="12"></v-col></v-row></div> -->

    <div class="container-fluid title-page">
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <h2>Log</h2>
        </v-col>
      </v-row>
    </div>

    <div class="container-fluid">
      <v-row>

        <v-col cols="12" sm="12" md="12">
          <v-card class="list-app">
            <v-card-title>
              Registros de visualizações
              <v-text-field class="search-log" color="white" dark v-model="search" append-icon="search" label="Busca" single-line hide-details></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="logs" :search="search" :value="logs" :pagination.sync="pagination" :loading="loading">
              <template slot="items" slot-scope="props">
                <tr @click="showDetails(props.item)" style="cursor:pointer;">
                  <td>{{ props.item.user }}</td>
                  <td class="text-xs-left">{{ props.item.course }}</td>
                  <td class="text-xs-left">{{ props.item.attempt }}</td>
                  <td class="text-xs-center">{{ props.item.percentage }}</td>
                </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="orange" icon="info">
                Sem resultados para "{{ search }}"
              </v-alert>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialogDetails" width="720">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Detalhes
        </v-card-title>

        <v-card-text>
          <p><strong>{{ logSelect.attempt }}ª</strong> tentativa de <strong>{{ logSelect.user }}</strong> no curso <strong>{{ logSelect.course }}</strong></p>
          <v-data-table hide-actions :headers="headersDetails" :items="logSelect.details" :value="logs">
            <template slot="items" slot-scope="props">
              <tr>
                <td class="text-xs-left">{{ props.item.content }}</td>
                <td class="text-xs-left">{{ props.item.module }}</td>
                <td class="text-xs-center">{{ props.item.percentage }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="dialogDetails = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'Log',
    data () {
      return {
        loading: true,
        dialogDetails: false,
        logSelect: {},
        search: '',
        headers: [
          { text: 'Usuário', align: 'left', sortable: true, value: 'user' },
          { text: 'Curso', value: 'course' },
          { text: 'Tentativa', value: 'attempt' },
          { text: 'Média da Conclusão (%)', value: 'percentage', align: 'center' }
        ],
        headersDetails: [
          { text: 'Conteúdo', align: 'left', sortable: true, value: 'content' },
          { text: 'Módulo', value: 'module' },
          { text: 'Conclusão (%)', value: 'percentage', align: 'center' }
        ],
        logs: [],
        pagination: {
          rowsPerPage: 25
        }
      }
    },
    watch: {
      dialogDetails(val) {
        if (!val) {
          this.logSelect = {}
        }
      }
    },
    methods: {
      showDetails (item) {
        this.logSelect = Object.assign({}, item)

        this.logSelect.details = item.details.map(detail => {
          let module

          if (detail.module) {
            module = detail.module.title
          }

          return {
            content: detail.title,
            module,
            percentage: detail.percentage
          }
        })
        this.dialogDetails = true
      },
      getLog () {
        /* eslint-disable */
        axios.get('/log').then(response => {
          if (response.data.success) {
            this.logs = response.data.logs.map(log => {
              return {
                user: log.user.name,
                course: log.course ? log.course.title : '',
                attempt: log.attempt,
                percentage: log.coursePercentage.toFixed(2),
                details: log.details
              }
            })
          }
        }).finally(() => {
          this.loading = false
        })
      }
    },
    created () {
      this.getLog()
    }
  }
</script>
